'use client';

import { handleHeaderColorScheme } from '@lib/store/slices/ComponentsSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useScroll from '../hooks/useScroll';
import { useViewport } from '../hooks/useViewport';

const ScrollHelper = () => {
  const dispatch = useDispatch();

  const { scrollY } = useScroll();
  const { isMobile } = useViewport();

  useEffect(() => {
    dispatch(handleHeaderColorScheme('whiteOnTransparent'));
    return function () {
      dispatch(handleHeaderColorScheme(''));
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      if (scrollY < window.innerHeight) {
        dispatch(handleHeaderColorScheme('whiteOnTransparent'));
      } else {
        dispatch(handleHeaderColorScheme(''));
      }
    } else {
      if (scrollY < (866 / 1601) * window.innerWidth) {
        dispatch(handleHeaderColorScheme('whiteOnTransparent'));
      } else {
        dispatch(handleHeaderColorScheme(''));
      }
    }
  }, [scrollY, isMobile]);

  return null;
};

export default ScrollHelper;
